import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import { devConfig } from 'config/config'; // Import development configuration
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component

/**
 * Class representing the products view.
 * @extends JetView
 */
export default class productsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const screen = this.app.config.size; // Current screen size
        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            id: 'a10', // Unique identifier for the form
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    type: 'wide', // Wide layout type
                    responsive: 'a10', // Responsive layout identifier
                    margin: 10, // Margin around the layout
                    cols: [
                        {
                            localId: 'inner:layout', // Local identifier for the inner layout
                            gravity: 4, // Gravity for layout distribution
                            type: 'wide', // Wide layout type
                            rows: [
                                {
                                    view: 'tabbar', // Tabbar component
                                    localId: 'tabbar', // Local identifier for the tabbar
                                    height: screen == 'small' ? 75 : 45, // Dynamic height based on screen size
                                    options: [
                                        // Tab options
                                        {
                                            id: 'partner.products.partnersProducts', // Identifier for the tab
                                            value: _('Activacion Productos'), // Localized tab label
                                        },
                                        {
                                            id: 'partner.products.partnersProviders', // Identifier for the tab
                                            value: _('Partners Proveedores'), // Localized tab label
                                        },
                                        {
                                            id: 'partner.products.partnersSubProviders', // Identifier for the tab
                                            value: _('Partners Sub Proveedores'), // Localized tab label
                                        },
                                        {
                                            id: 'partner.products.partnersTypeProduct', // Identifier for the tab
                                            value: _('Partners Tipo'), // Localized tab label
                                        },
                                        {
                                            id: 'partner.products.categoriesProducts', // Identifier for the tab
                                            value: _('Categorías Productos'), // Localized tab label
                                        },
                                        {
                                            id: 'partner.products.productsBanks', // Identifier for the tab
                                            value: _('Productos a Bancos'), // Localized tab label
                                        },
                                        {
                                            id: 'partner.products.productsFranchises', // Identifier for the tab
                                            value: _('Franquicias Productos'), // Localized tab label
                                        },
                                    ],
                                },
                                { $subview: true }, // Placeholder for subview
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and its components.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use the Menu plugin with the tabbar
    }
}

// FILE DOCUMENTED
